import { Radio, LabeledContainer } from '@schibsted-svp/react-ui';
import { MediaLiveInputType } from 'services/admin-bff/contants';
import { useMediaLiveInputFormContext, useReservedMediaLiveInputs } from './hooks';

import css from './MediaLiveInput.module.scss';

export function MediaLiveInput() {
    const { formApi } = useMediaLiveInputFormContext();
    const { register, resetField } = formApi;

    const inputs = useReservedMediaLiveInputs();
    const hasLinkInputs = inputs.some(({ type }) => type === MediaLiveInputType.LINK);

    return (
        <LabeledContainer label="Source type">
            <div className={css.radios}>
                <Radio
                    {...register('inputType', { onChange: () => resetField('inputId') })}
                    value={MediaLiveInputType.PUSH}
                    label="Generate key (push)"
                />
                <Radio
                    {...register('inputType', { onChange: () => resetField('inputId') })}
                    value={MediaLiveInputType.PULL}
                    label="External URL (pull)"
                />
                {hasLinkInputs && (
                    <Radio
                        {...register('inputType', { onChange: () => resetField('inputId') })}
                        value={MediaLiveInputType.LINK}
                        label="Elemental Link"
                    />
                )}
            </div>
        </LabeledContainer>
    );
}
